
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[myname]",
      function () {
        return require("private-next-pages/c/[myname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[myname]"])
      });
    }
  